import React from 'react';
import PropTypes from 'prop-types';
import Filler from './Filler';

import './ProgressBar.css';

export default function ProgressBar(props) {
  const { percentage, background } = props;
  return (
    <div className="progress-bar">
      <Filler percentage={percentage} background={background} />
    </div>
  );
}

ProgressBar.propTypes = {
  percentage: PropTypes.number,
  background: PropTypes.string,
};

ProgressBar.defaultProps = {
  percentage: 0,
  background: '#AAA',
};
